import { connect } from 'react-redux';
import GarageSelection from 'components/bids/BidSelectionSteps/GarageSelection';
import { searchGarages, clearGaragesData } from 'data/garages/Garages.actions';

const mapStateToProps = (state, ownProps) => {
  return {
    garages: state.garages.garagesData || [],
    fetching: state.garages.fetchingGarages,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onClearGarages: () => dispatch(clearGaragesData()),
    onSearchGarages: afm => dispatch(searchGarages(afm)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GarageSelection);
